var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistNoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_152",
    "data-name": "Raggruppa 152",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.306,
    height: 30.306,
    viewBox: "0 0 30.306 30.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_176",
    "data-name": "Tracciato 176",
    d: "M15.153,30.306A15.153,15.153,0,1,1,30.306,15.153,15.153,15.153,0,0,1,15.153,30.306Z",
    fill: "#e40505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_177",
    "data-name": "Tracciato 177",
    d: "M17.57,12.463a2,2,0,1,1,2-2A2,2,0,0,1,17.57,12.463Z",
    transform: "translate(4.092 2.225)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_178",
    "data-name": "Tracciato 178",
    d: "M7.261,12.463a2,2,0,1,1,2-2A2,2,0,0,1,7.261,12.463Z",
    transform: "translate(1.383 2.225)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_179",
    "data-name": "Tracciato 179",
    d: "M19.373,17.99a.646.646,0,0,1-.43.809.734.734,0,0,1-.189.034.64.64,0,0,1-.62-.465A5.137,5.137,0,0,0,8.4,18.352a.648.648,0,0,1-1.24-.379,6.434,6.434,0,0,1,12.208.017Z",
    transform: "translate(1.875 3.568)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_180",
    "data-name": "Tracciato 180",
    d: "M19.615,8.894a.371.371,0,0,1-.189-.034l-3.84-1.136a.648.648,0,0,1,.379-1.24L19.8,7.62a.652.652,0,0,1-.189,1.274Z",
    transform: "translate(3.975 1.696)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_181",
    "data-name": "Tracciato 181",
    d: "M5.263,7.633,9.1,6.5a.648.648,0,0,1,.379,1.24L5.642,8.873a.732.732,0,0,1-.189.034.662.662,0,0,1-.62-.465A.653.653,0,0,1,5.263,7.633Z",
    transform: "translate(1.263 1.7)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistNoActive);
export default __webpack_public_path__ + "static/media/ChecklistNoActive.d08b35bd364348f725d343341676d2df.svg";
export { ForwardRef as ReactComponent };